import { B } from "../domain/context.js";
import { card } from "../components/ui.js";
import { esc } from "../lib/fmt.js";

// ---------- YEMEK MENÜSÜ ----------
export function viewMenu() {
  const t = B();
  const days = Object.keys(t.menu);
  const today = new Date().toLocaleDateString("tr-TR", { weekday: "long" });
  return `
  ${card(`<div class="p-4 flex items-start gap-3 text-sm">
    <span class="text-xl">⚠️</span><p class="text-inksoft">${esc(t.menuNote)}</p>
  </div>`, "mb-4 !bg-sun-soft !border-sun/30")}
  <div class="grid gap-4 md:grid-cols-2 xl:grid-cols-3">
    ${days.map(d => card(`
      <div class="p-5 ${d === today ? "" : ""}">
        <div class="flex items-center justify-between mb-3">
          <h2 class="font-display font-bold">${d}</h2>
          ${d === today ? `<span class="text-[10px] font-bold uppercase tracking-wide rounded-full bg-teal text-white px-2.5 py-1">Bugün</span>` : ""}
        </div>
        <div class="space-y-3 text-sm">
          <div><div class="text-[11px] font-bold text-inksoft mb-0.5">🥐 KAHVALTI</div>${esc(t.menu[d].kahvalti)}</div>
          <div><div class="text-[11px] font-bold text-inksoft mb-0.5">🍲 ÖĞLE</div>${esc(t.menu[d].ogle)}</div>
          <div><div class="text-[11px] font-bold text-inksoft mb-0.5">🍎 İKİNDİ</div>${esc(t.menu[d].ikindi)}</div>
        </div>
      </div>`, d === today ? "ring-2 ring-teal" : "")).join("")}
  </div>`;
}

